export default __webpack_public_path__ + "../staticImages/icon-angebote.svg";